import { LoadingContainer } from 'peach/components'
import { useHistory, useParams } from 'peach/router'

import { DynamicForm, Page, PageHeader } from 'core/components'
import { useLoanTapeTypeCreate } from 'core/types'
import { loanTapeTypeSchema } from 'core/utils/generated/formSchemas'

const CreateLoanTapeType = () => {
  const history = useHistory()
  const { companyId } = useParams<{ companyId?: string }>()

  const { mutateAsync: createTapeType } = useLoanTapeTypeCreate({ companyId })

  return (
    <LoadingContainer isLoading={false}>
      <Page variant='full'>
        <PageHeader title='Create Loan Tape Type' />
        <DynamicForm
          data={{}}
          fieldEditMode='all'
          fieldOverrides={{
            fields: 'JsonInput',
            fieldNameMappings: 'JsonInput',
            loanMetaDataFields: 'JsonInput',
          }}
          onSubmit={async (payload: any) => {
            const res = await createTapeType(payload)
            const id = (res as any)?.data?.id as string | undefined
            if (id) {
              history.push(`/companies/${companyId}/loan-tape-types/${id}`)
            } else {
              history.push(`/companies/${companyId}/loan-tape-types`)
            }
          }}
          schema={loanTapeTypeSchema}
          submitText='Create'
          validationRules={{
            tapeName: [
              (v: unknown) =>
                (typeof v === 'string' && v.trim().length > 0) ||
                'tapeName is required',
            ],
            tapeType: [
              (v: unknown) =>
                (typeof v === 'string' && v.trim().length > 0) ||
                'tapeType is required',
            ],
          }}
        />
      </Page>
    </LoadingContainer>
  )
}

export default CreateLoanTapeType
